import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class Helper {
    /**
     * Returns only the URL path, removing query params (`?`) and fragment (`#`).
     *
     * It cuts the string at the first occurrence of either:
     * - `?` (start of query string), or
     * - `#` (start of fragment)
     *
     * Examples:
     * - "/chapters/1?tab=x#anchor" -> "/chapters/1"
     * - "/chapters/1#anchor" -> "/chapters/1"
     * - "/chapters/1?tab=x" -> "/chapters/1"
     * - "/chapters/1" -> "/chapters/1"
     */
    removeFragmentAndQuery(url: string): string {
        const queryIndex = url.indexOf('?');
        const fragmentIndex = url.indexOf('#');

        // Keep only valid indexes, then take the earliest one.
        const firstSeparatorIndex = [queryIndex, fragmentIndex].filter(index => index >= 0).sort((a, b) => a - b)[0];

        return firstSeparatorIndex !== undefined ? url.substring(0, firstSeparatorIndex) : url;
    }
}
